export default {
    namespaced: true,
    state: {
      windowHeight: document.documentElement.clientHeight,
      windowWidth: document.documentElement.clientWidth
    },
    mutations: {
      setResize (state, value) {
        state.windowHeight = document.documentElement.clientHeight
        state.windowWidth = document.documentElement.clientWidth
      }
    },
    actions: {
      getResize (context, payload) {
        window.addEventListener('resize', () => {
          context.commit('setResize')
        })
      }

    }
  }



// WEBPACK FOOTER //
// ./src/store/modules/layout.js